const env = typeof process !== 'undefined' && process.env ? process.env : {};
const isLocalBrowser =
  typeof window !== 'undefined' &&
  ['localhost', '127.0.0.1'].includes(window.location.hostname);

export const AI_FUNCTIONS_BASE_URL =
  isLocalBrowser
    ? 'http://localhost:7071'
    : (
        env.REACT_APP_AI_FUNCTIONS_URL ||
        env.REACT_APP_FUNCTIONS_URL ||
        'https://jobseriessearchfunctionapp.azurewebsites.net'
      );

export const SAVE_LOAD_FUNCTIONS_BASE_URL =
  env.REACT_APP_SAVE_LOAD_FUNCTIONS_URL ||
  'https://savefunction.azurewebsites.net';

if (env.NODE_ENV === 'development') {
  console.info(`[API configuration] AI functions: ${AI_FUNCTIONS_BASE_URL}`);
  console.info(`[API configuration] Save/load functions: ${SAVE_LOAD_FUNCTIONS_BASE_URL}`);
}
